import type { CMSColumnDTO } from "~/features/cms/types/dto";
import { useNumericScreenSize } from "~/common/hooks/useNumericScreenSize";
import { useCMSComponentRenderer } from "~/features/cms/CMSComponentRendererContext";
import { styled } from "@schaeffler-commerce/design-system";
import { makeExternallyStyledElement } from "~/features/cms/utils/styles";

interface Props extends Omit<CMSColumnDTO, "type"> {
  className?: string;
}

export const CMSColumn = (props: Props) => {
  const renderCMSComponent = useCMSComponentRenderer();
  const pageSize = useNumericScreenSize();
  const width =
    props.widths
      // Take widths from all breakpoints up to current one as candidates
      .slice(0, pageSize)
      // Filter out nulls
      .filter(Boolean)
      // Take the last one, meaning the one that is closest to the current breakpoint
      .reverse()[0] ?? 100;
  return (
    <ColumnOuter className={props.className} style={{ width: `${width}%` }}>
      <StyledColumnInner rootStyles={props.rootStyles}>
        {props.children.map((child, index) => {
          return renderCMSComponent(child, undefined, index);
        })}
      </StyledColumnInner>
    </ColumnOuter>
  );
};

const ColumnOuter = styled("div")({
  flex: "none",
  padding: `calc(var(--gutter) / 2)`,
});

const ColumnInner = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 16,
});
const StyledColumnInner = makeExternallyStyledElement(ColumnInner);
